$('.container_area').css('display','none');
$('.container_area_call').css('display','block');
$('.element-comments-click').click(function () {
    var idThis= this.id;
    $('.h1_note').removeClass('active_h1_note');
    $('.h1_call').removeClass('active_h1_call');
    $('.h1_date').removeClass('active_h1_date');
    $('.container_area').css('display','none');
    if(idThis == 1){
        $('.h1_note').addClass('active_h1_note');
        $('.container_area_note').css('display','block');
    }
    if(idThis == 2){
        $('.h1_call').addClass('active_h1_call');
        $('.container_area_call').css('display','block');
    }
    if(idThis == 3){
        $('.h1_date').addClass('active_h1_date');
        $('.container_area_date').css('display','block');
    }
});

$('.btnSaveNote').click(function () {
    if($('#notaText').val() == ""){
        swal({
            text: "Debes escribir una nota",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });

    $.ajax({
        url: https + "saveNoteProspect",
        method: "POST",
        data: {note: $('#notaText').val(),prospects_id:$('#idViewsProspect').val(),action:'saveNoteProspect'},
        success: function (data) {
            if ($.trim(data) == "1") {
                swal.close();
                swal({
                    text: "Nota creada con exito",
                    icon: imageURL,
                    button: "OK!",
                });
                setInterval(function () {
                    location.reload();
                },200);
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

$('.btnSaveCall').click(function () {

    if($('#text_call').val() == ""){
        swal({
            text: "Debes escribir un texto",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    if($('#date_call').val() == ""){
        swal({
            text: "Debes digitar una fecha",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    if($('#hour_call').val() == ""){
        swal({
            text: "Debes digitar una hora",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });

    $.ajax({
        url: https + "saveCallProspect",
        method: "POST",
        data: {
            text: $('#text_call').val(),
            date: $('#date_call').val(),
            hour: $('#hour_call').val(),
            prospects_id:$('#idViewsProspect').val(),
            action:'saveCallProspect'
        },
        success: function (data) {
            if ($.trim(data) == "1") {
                swal.close();
                swal({
                    text: "Llamada creada con exito",
                    icon: imageURL,
                    button: "OK!",
                });
                setInterval(function () {
                    location.reload();
                },200);
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

$('.btnSaveDate').click(function () {

    if($('#text_date').val() == ""){
        swal({
            text: "Debes escribir un texto",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    if($('#date_date').val() == ""){
        swal({
            text: "Debes digitar una fecha",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    if($('#hour_date').val() == ""){
        swal({
            text: "Debes digitar una hora",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });

    $.ajax({
        url: https + "saveDateProspect",
        method: "POST",
        data: {
            text: $('#text_date').val(),
            date: $('#date_date').val(),
            hour: $('#hour_date').val(),
            prospects_id:$('#idViewsProspect').val(),
            action:'saveDateProspect'
        },
        success: function (data) {
            if ($.trim(data) == "1") {
                swal.close();
                swal({
                    text: "Cita creada con exito",
                    icon: imageURL,
                    button: "OK!",
                });
                setInterval(function () {
                    location.reload();
                },200);
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

$('.check_date_prospects').click(function () {
    var id_check_date_prospects = this.id;
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    check_date_prospects(id_check_date_prospects);
});

function check_date_prospects(id){
    swal({
        title: "¿Seguro de hacer esto?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                $.ajax({
                    url: https + "statusDateProspect",
                    method: "POST",
                    data: {
                        id: id,
                        action:'statusDateProspect'
                    },
                    success: function (data) {
                        if ($.trim(data) == "1") {
                            swal.close();
                            swal({
                                text: "Cita actualizada con exito",
                                icon: imageURL,
                                button: "OK!",
                            });
                            setInterval(function () {
                                //location.reload();
                            },200);
                            if($('#check_date_prospects_'+id).is(':checked')){
                                $('#check_date_prospects_element_'+id).addClass('active_3');
                            }else{
                                $('#check_date_prospects_element_'+id).removeClass('active_3');
                            }
                        }else if($.trim(data) == "2") {
                            swal({
                                text: "No tiene los permisos necesarios",
                                icon: imageURL,
                                button: "OK!",
                            });
                        }else {
                            swal({
                                text: "Error, hubo problemas",
                                icon: imageURL,
                                button: "OK!",
                            });
                        }
                    }
                });
            } else {
                if($('#check_date_prospects_'+id).is(':checked')){
                    $('#check_date_prospects_'+id).prop('checked',false);
                }else{
                    $('#check_date_prospects_'+id).prop('checked',true);
                }
                return false;
            }
        });
}

$('.check_call_prospects').click(function () {
    var id_check_call_prospects = this.id;
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    check_call_prospects(id_check_call_prospects);
});

function check_call_prospects(id){
    swal({
        title: "¿Seguro de hacer esto?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                $.ajax({
                    url: https + "statusCallProspect",
                    method: "POST",
                    data: {
                        id: id,
                        action:'statusCallProspect'
                    },
                    success: function (data) {
                        if ($.trim(data) == "1") {
                            swal.close();
                            swal({
                                text: "Llamada actualizada con exito",
                                icon: imageURL,
                                button: "OK!",
                            });
                            setInterval(function () {
                                //location.reload();
                            },200);
                            if($('#check_call_prospects_'+id).is(':checked')){
                                $('#check_call_prospects_element_'+id).addClass('active_2');
                            }else{
                                $('#check_call_prospects_element_'+id).removeClass('active_2');
                            }
                        }else if($.trim(data) == "2") {
                            swal({
                                text: "No tiene los permisos necesarios",
                                icon: imageURL,
                                button: "OK!",
                            });
                        }else {
                            swal({
                                text: "Error, hubo problemas",
                                icon: imageURL,
                                button: "OK!",
                            });
                        }
                    }
                });
            } else {
                if($('#check_call_prospects_'+id).is(':checked')){
                    $('#check_call_prospects_'+id).prop('checked',false);
                }else{
                    $('#check_call_prospects_'+id).prop('checked',true);
                }
                return false;
            }
        });
}

$('.check_prospects').click(function () {
    var id_check_prospects = this.id;
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    check_prospects(id_check_prospects);
});

function check_prospects(id){
    swal({
        title: "¿Seguro de hacer esto?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                $.ajax({
                    url: https + "statusCheckProspect",
                    method: "POST",
                    data: {
                        id: id,
                        action:'statusCheckProspect'
                    },
                    success: function (data) {
                        if ($.trim(data) == "1") {
                            swal.close();
                            swal({
                                text: "Actualizada con exito",
                                icon: imageURL,
                                button: "OK!",
                            });
                            setInterval(function () {
                                //location.reload();
                            },200);
                            if($('#check_prospects_'+id).is(':checked')){
                                $('#check_prospects_element_'+id).addClass('active');
                            }else{
                                $('#check_prospects_element_'+id).removeClass('active');
                            }
                        }else if($.trim(data) == "2") {
                            swal({
                                text: "No tiene los permisos necesarios",
                                icon: imageURL,
                                button: "OK!",
                            });
                        }else {
                            swal({
                                text: "Error, hubo problemas",
                                icon: imageURL,
                                button: "OK!",
                            });
                        }
                    }
                });
            } else {
                if($('#check_prospects_'+id).is(':checked')){
                    $('#check_prospects_'+id).prop('checked',false);
                }else{
                    $('#check_prospects_'+id).prop('checked',true);
                }
                return false;
            }
        });
}